export const getBenefitName = (benefit) => {
  switch (benefit) {
    case "010":
      return "ACCIDENTAL DEATH BENEFIT RIDER";
    case "011":
      return "ACCIDENTAL DEATH BENEFIT RIDER";
    case "017":
      return "LONG TERM CARE RIDER";
    case "071":
      return "CRITICAL ILLNESS RIDER";
    case "072":
      return "TERMINAL ILLNESS RIDER";
    case "073":
      return "CHRONIC ILLNESS RIDER";
    case "020":
      return "WAIVER OF PREMIUM RIDER";
    case "021":
      return "MONTHLY INCOME DISABILITY BENEFIT";
    case "022":
      return "WAIVER OF PREMIUM RIDER";
    case "070":
      return "GUARANTEED INSURANCE OPTION RIDER";
    case "080":
      return "PAYOR BENEFIT DISABILITY";
    case "081":
      return "PAYOR BENEFIT DISABILITY";
    case "130":
      return "PREMIUM DEPOSIT FUND";
    case "143":
      return "ANNUITY PURCHASE OPTION";
    default:
      return benefit;
  }
};
